// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* insights */
body {
  font-family: "Poppins", serif;
}

.container-fluid.MainBox {
    display: flex
}

.platformtitle span {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
}

/* .wrapping-box {
    background: var(--Bg, #f9f5f6);
} */

.wrapping-box-content {
  display: flex;
  flex-direction: column;
}

.campaign-names ul li {
  list-style-type: disc;
  color: rgba(107, 71, 80, 1);
  font-family: "Poppins", serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
}

.text-date {
  color: rgba(0, 0, 0, 0.3);
  font-weight: 400;
  font-size: 16px;
  font-family: "Poppins", serif;

}

.MainBox.g-4.row {
  width: 100%;
}

.options-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.platformtitle {
  color: #6b8e76;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.02em;
  font-size: 18px;
  text-align: center;
}

.first-container {
  display: flex;
  height: 432px;
  overflow-y: scroll;
}

.first-container::-webkit-scrollbar {
  display: none;
}

.left-container {
  flex: 1 1;
  background: #fff;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 0.5rem;
  height: 96%;
}

.right-top-actions {
  display: flex;
  align-items: center;
  gap: 4px;

  color: #6b8e76;

  cursor: pointer;
}

.right-top-actions span {
  font-family: "Poppins", serif;
  font-size: 12px;
  font-weight: 400;
}

.no-data {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--New-form-color, #6b4750);
  font-family: "Poppins", serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-align: center;
}

.view-all img {
  height: 0.9rem;
}

.pie-chart {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-content {
  color: var(--New-form-color, #6b4750);
  font-family: "Poppins", serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-align: center;
}

.right-container {
  flex-basis: 60%;
  display: flex;
  flex-direction: row;
  height: 100%;
}

.social-corner {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.text-content {
  text-align: center;
  color: rgba(107, 142, 118, 1);
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.02em;
}

.socials-stats {
  display: flex;
  justify-content: space-evenly;
  margin-top: 5%;
}

.socials-stats .reels {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.number-content {
  text-align: center;
  margin-top: 5%;
}

.ig-box {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  transition: box-shadow 0.3s ease;
}

.ig-box p {
  font-size: 2rem;
  color: rgba(103, 103, 103, 1);
  font-family: "Poppins", serif;
  font-weight: 400;
  letter-spacing: 0.64px;
}

.ig-box small {
  color: var(--New-form-color, #6b4750);
  font-size: 1rem;
  font-family: "Poppins", serif;
  font-weight: 400;
  letter-spacing: 0.32px;
  cursor: pointer;
  text-align: center;
}

.second-container {
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
}

.third-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.campaign-performance-box {
  width: 55%;
  border-radius: 15px;
  background-color: white;
  margin-right: 15px;
  padding: 20px;
}

.campaign-names {
  display: flex;
  flex-direction: column;
  margin-top: 5%;
}

.campaign-date {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.campaign-date ul {
  margin: 0;
  display: flex;
  width: 80%;
}

.campaign-date p {
  color: rgba(0, 0, 0, 0.3);
  font-family: "Poppins", serif;
  font-size: 16px;
  font-weight: 400;
  padding-right: 1.5rem;
  margin: 0;
}

.influencer-performance-box {
  background: #fff;
  border-radius: 15px;
  width: 70%;
  padding: 20px 40px;
}

.influencer-wrapper-container {
  display: flex;
  justify-content: space-between;
}

.nameofinfluencer {
  display: flex;
  align-items: center;
}

.nameofinfluencer img {
  margin-right: 10px;
}

.audience-stats p {
  font-size: 32px;
  font-weight: 500;
  margin-right: 10px;
}

.audience-stats {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.audience-stats span {
  margin-right: 20px;
  margin-left: 11px;
  line-height: 16px;
  position: relative;
  top: 7px;
}

.nameofinfluencer {
  font-size: 16px;
  font-weight: 400;
  color: #6B4750;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 480px) {
  .influencer-wrapper-container {
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
  }

  .trophy-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }
}

@media (max-width: 1226px) {
  .MainBox {
    flex-direction: column;
    width: 100%;
  }

  .Box {
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 20px;
    width: 100% !important;
  }
}

@media (max-width: 991px) {
  .wrapping-box-content {
    margin-left: 0%;
    padding: 50px 20px;
  }
}
/* Add this to your CSS file */
.no-style-link {
  text-decoration: none;  /* Removes underline */
  color: inherit;         /* Inherits the text color from parent */
  display: inline-block;   /* Ensures the layout behaves like an inline element */
}
`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Brand/Insights/Insights.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,6BAA6B;AAC/B;;AAEA;IACI;AACJ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;;AAE/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA,8BAA8B;AAC9B;EACE,qBAAqB,GAAG,sBAAsB;EAC9C,cAAc,UAAU,wCAAwC;EAChE,qBAAqB,IAAI,sDAAsD;AACjF","sourcesContent":["/* insights */\nbody {\n  font-family: \"Poppins\", serif;\n}\n\n.container-fluid.MainBox {\n    display: flex\n}\n\n.platformtitle span {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n}\n\n/* .wrapping-box {\n    background: var(--Bg, #f9f5f6);\n} */\n\n.wrapping-box-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.campaign-names ul li {\n  list-style-type: disc;\n  color: rgba(107, 71, 80, 1);\n  font-family: \"Poppins\", serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n}\n\n.text-date {\n  color: rgba(0, 0, 0, 0.3);\n  font-weight: 400;\n  font-size: 16px;\n  font-family: \"Poppins\", serif;\n\n}\n\n.MainBox.g-4.row {\n  width: 100%;\n}\n\n.options-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.platformtitle {\n  color: #6b8e76;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  line-height: 30px;\n  letter-spacing: 0.02em;\n  font-size: 18px;\n  text-align: center;\n}\n\n.first-container {\n  display: flex;\n  height: 432px;\n  overflow-y: scroll;\n}\n\n.first-container::-webkit-scrollbar {\n  display: none;\n}\n\n.left-container {\n  flex: 1;\n  background: #fff;\n  box-sizing: border-box;\n  padding: 10px;\n  border-radius: 0.5rem;\n  height: 96%;\n}\n\n.right-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  color: #6b8e76;\n\n  cursor: pointer;\n}\n\n.right-top-actions span {\n  font-family: \"Poppins\", serif;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.no-data {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--New-form-color, #6b4750);\n  font-family: \"Poppins\", serif;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0.4px;\n  text-align: center;\n}\n\n.view-all img {\n  height: 0.9rem;\n}\n\n.pie-chart {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bottom-content {\n  color: var(--New-form-color, #6b4750);\n  font-family: \"Poppins\", serif;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0.4px;\n  text-align: center;\n}\n\n.right-container {\n  flex-basis: 60%;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n.social-corner {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.text-content {\n  text-align: center;\n  color: rgba(107, 142, 118, 1);\n  font-family: \"Poppins\", sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n  letter-spacing: 0.02em;\n}\n\n.socials-stats {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 5%;\n}\n\n.socials-stats .reels {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.number-content {\n  text-align: center;\n  margin-top: 5%;\n}\n\n.ig-box {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  border-radius: 15px;\n  padding: 10px;\n  transition: box-shadow 0.3s ease;\n}\n\n.ig-box p {\n  font-size: 2rem;\n  color: rgba(103, 103, 103, 1);\n  font-family: \"Poppins\", serif;\n  font-weight: 400;\n  letter-spacing: 0.64px;\n}\n\n.ig-box small {\n  color: var(--New-form-color, #6b4750);\n  font-size: 1rem;\n  font-family: \"Poppins\", serif;\n  font-weight: 400;\n  letter-spacing: 0.32px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.second-container {\n  height: auto;\n  background: #fff;\n  border-radius: 15px;\n  padding: 10px;\n}\n\n.third-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.campaign-performance-box {\n  width: 55%;\n  border-radius: 15px;\n  background-color: white;\n  margin-right: 15px;\n  padding: 20px;\n}\n\n.campaign-names {\n  display: flex;\n  flex-direction: column;\n  margin-top: 5%;\n}\n\n.campaign-date {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.campaign-date ul {\n  margin: 0;\n  display: flex;\n  width: 80%;\n}\n\n.campaign-date p {\n  color: rgba(0, 0, 0, 0.3);\n  font-family: \"Poppins\", serif;\n  font-size: 16px;\n  font-weight: 400;\n  padding-right: 1.5rem;\n  margin: 0;\n}\n\n.influencer-performance-box {\n  background: #fff;\n  border-radius: 15px;\n  width: 70%;\n  padding: 20px 40px;\n}\n\n.influencer-wrapper-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.nameofinfluencer {\n  display: flex;\n  align-items: center;\n}\n\n.nameofinfluencer img {\n  margin-right: 10px;\n}\n\n.audience-stats p {\n  font-size: 32px;\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n.audience-stats {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 30px;\n}\n\n.audience-stats span {\n  margin-right: 20px;\n  margin-left: 11px;\n  line-height: 16px;\n  position: relative;\n  top: 7px;\n}\n\n.nameofinfluencer {\n  font-size: 16px;\n  font-weight: 400;\n  color: #6B4750;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 480px) {\n  .influencer-wrapper-container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 0.5rem;\n  }\n\n  .trophy-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 30px;\n  }\n}\n\n@media (max-width: 1226px) {\n  .MainBox {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .Box {\n    justify-content: space-between;\n    padding: 16px;\n    margin-bottom: 20px;\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .wrapping-box-content {\n    margin-left: 0%;\n    padding: 50px 20px;\n  }\n}\n/* Add this to your CSS file */\n.no-style-link {\n  text-decoration: none;  /* Removes underline */\n  color: inherit;         /* Inherits the text color from parent */\n  display: inline-block;   /* Ensures the layout behaves like an inline element */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
